module.exports = __webpack_public_path__ + "img/fi-rr-folder-add.33c0e8bf.svg";